/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_ToggleInputs */

const en_settings_toggle = /** @type {(inputs: Settings_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle`)
};

const he_settings_toggle = /** @type {(inputs: Settings_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`החלף`)
};

/**
* | output |
* | --- |
* | "Toggle" |
*
* @param {Settings_ToggleInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_toggle = /** @type {((inputs?: Settings_ToggleInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_ToggleInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_toggle(inputs)
	return he_settings_toggle(inputs)
});